module.exports = __webpack_public_path__ + "img/downloadTips.5ad942d7.webp";